import { Routes } from '@angular/router';

// Layouts
import { CommonLayoutComponent } from './common/common-layout.component';
import { AuthenticationLayoutComponent } from './common/authentication-layout.component';

// Guard
import {AuthenticationGuard} from './authentication/authentication.guard';

export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
    {
        path: '',
        component: CommonLayoutComponent,
        canActivate: [AuthenticationGuard],
        children: [
            {
                path: 'dashboard',
                loadChildren: './dashboard/dashboard.module#DashboardModule'
            },
            {
                path: 'apps',
                loadChildren: './apps/apps.modules#AppsModule'
            },
            {
                path: 'ui-elements',
                loadChildren: './ui-elements/ui-elements.modules#UiElementsModule'
            },
            {
                path: 'tables',
                loadChildren: './tables/tables.modules#TablesModule'
            },
            {
                path: 'pages',
                loadChildren: './pages/pages.modules#PagesModule'
            },
            {
                path: 'maps',
                loadChildren: './maps/maps.modules#MapsModule'
            },
            {
                path: 'extras',
                loadChildren: './extras/extras.modules#ExtrasModule'
            }
        ]
    },
    {
        path: '',
        component: AuthenticationLayoutComponent,
        children: [
            {
                path: 'authentication',
                loadChildren: './authentication/authentication.modules#AuthenticationModule'
            }
        ]
    }
];

